(function () {
  if (window.__lmjCartTimer) return;
  window.__lmjCartTimer = true;

  var KEY = 'lmj_cc_end';
  var APPLIED_KEY = 'lmj_cc_applied';
  var COOLDOWN_MS = 24 * 60 * 60 * 1000; // after it ends, it does not restart for 24h

  // Testing shortcut: add ?lmj_reset=1 to any URL to restart the countdown.
  try {
    if (/[?&]lmj_reset=1/.test(location.search)) {
      localStorage.removeItem(KEY);
      sessionStorage.removeItem(APPLIED_KEY);
    }
  } catch (e) {}

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }

  function write(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  var mem = null; // fallback if localStorage is blocked
  var applying = false;

  function state(minutes) {
    var now = Date.now();
    var s = read() || mem;
    if (!s || (s.end <= now && now - s.end > COOLDOWN_MS)) {
      s = { end: now + minutes * 60 * 1000 };
      write(s);
      try { sessionStorage.removeItem(APPLIED_KEY); } catch (e) {}
    }
    mem = s;
    return s;
  }

  // Applies the welcome code to the cart (used at checkout) once per countdown, only while it is running.
  function applyCode(code) {
    if (!code || applying) return;
    try { if (sessionStorage.getItem(APPLIED_KEY) === String(mem && mem.end)) return; } catch (e) {}
    applying = true;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        try { sessionStorage.setItem(APPLIED_KEY, String(mem && mem.end)); } catch (e) {}
      })
      .catch(function () {})
      .then(function () { applying = false; });
  }

  function tick() {
    var els = document.querySelectorAll('[data-lmj-minutes]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var minutes = parseInt(el.getAttribute('data-lmj-minutes'), 10) || 5;
      var left = Math.floor((state(minutes).end - Date.now()) / 1000);
      if (left <= 0) {
        el.hidden = true;
        continue;
      }
      el.hidden = false;
      var clock = el.querySelector('[data-lmj-clock]');
      if (clock) clock.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      applyCode(el.getAttribute('data-lmj-code'));
    }
  }

  tick();
  setInterval(tick, 1000);
})();
